import { CarbonOffset } from '../carbon-offsets';
import { CarbonRemoval } from '../carbon-removal';
import { HabitatRestoration } from '../habitat-restoration';
import { ImpactType } from '../impact';
import { Tree } from '../tree';
import { values } from '../utils';

export type UserImpactFields = {
  trees: Tree[];
  carbonOffsets: CarbonOffset[];
  carbonRemovals: CarbonRemoval[];
  habitatRestorations: HabitatRestoration[];
};

export const impactTypeToUserImpactField: Record<ImpactType, { key: keyof UserImpactFields; quantityField: string }> = {
  [ImpactType.TREES]: { key: 'trees', quantityField: 'value' },
  [ImpactType.CARBON_OFFSETS]: { key: 'carbonOffsets', quantityField: 'numberOfTonnes' },
  [ImpactType.CARBON_REMOVAL]: { key: 'carbonRemovals', quantityField: 'numberOfTonnes' },
  [ImpactType.HABITAT_RESTORATION]: { key: 'habitatRestorations', quantityField: 'numberOfMeters' },
};

export const fromImpactTypeToUserDocumentKey: Record<ImpactType, keyof UserImpactFields> = {
  [ImpactType.TREES]: 'trees',
  [ImpactType.CARBON_OFFSETS]: 'carbonOffsets',
  [ImpactType.CARBON_REMOVAL]: 'carbonRemovals',
  [ImpactType.HABITAT_RESTORATION]: 'habitatRestorations',
};

export type UserImpactTotals = Partial<{
  totalTrees: number;
  totalCarbonTonnes: number;
  totalCarbonRemovedTonnes: number;
  totalHabitatMetersRestored: number;
}>;

const impactTypeToTotalField: Record<ImpactType, keyof UserImpactTotals> = {
  [ImpactType.TREES]: 'totalTrees',
  [ImpactType.CARBON_OFFSETS]: 'totalCarbonTonnes',
  [ImpactType.CARBON_REMOVAL]: 'totalCarbonRemovedTonnes',
  [ImpactType.HABITAT_RESTORATION]: 'totalHabitatMetersRestored',
};

export const hasFundedImpact = (user: UserImpactTotals | null | undefined): boolean => {
  if (!user) return false;

  return values(impactTypeToTotalField).some(field => (user[field] ?? 0) > 0);
};
